export default function useGoogleMapAPIKey() {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!googleMapsApiKey) {
        console.warn("Google Maps API key is not set in environment variables.");
        return null;
    }
    return googleMapsApiKey;
}